// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.poulesCardContainer {
    width: 100%;
    display: flex;
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
    border-radius: 12px;
    background: #69C3C5;
}

.poulesCardContainer p{
    color: white;
font-family: Lato;
font-size: 20px;
font-style: normal;
font-weight: 700;
line-height: 100%; /* 12px */
}

.poulesCardSlider{
    width: 100%;
    min-height: 200px;
    overflow-y: auto;
}

.poulesCardSliderContent{
    width: 120%;
}

.poulesCardContainer {
    background-color: #69C3C5;
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 20px;
    color: #fff;
  }

  
  .poulesCardSlider {
    overflow-x: auto;
    padding: 16px 0;
  }
  
  .poulesCardSliderContent {
    display: inline-block;
  }
  
  .teamsTable {
    width: 100%;
    border-collapse: collapse;
    color: #fff;
  }
  
  .teamsTable th,
  .teamsTable td {
    padding: 8px;
    text-align: center;
    white-space: nowrap; /* Prevents table from breaking */
  }
  
  .teamsTable th {
    text-align: center;
    background-color: none;
    position: sticky;
    top: 0;
    font-family: Lato;
  }
  
  .teamInfo {
    display: flex;
    align-items: center;
    max-width: 200px;
    padding: 16px 0!important;
  }

  .teamInfo span{
    font-size: 100%;
  }
  
  .teamLogo {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 10px;
  }
  
  .points {
    width: 50px;
    background-color: #c3d32c;
    text-align: center;
    font-weight: bold;
    color: black;
  }

  th.points{
    border-radius: 8px 8px 0 0;
  }

  .teamsTable tbody tr:last-child td.points{
    border-radius:  0 0 8px 8px;
  }

  .defeat, .win, .null, .goalFor, .goalAgainst, .diff{
    width: 50px;
  }
  
  .teamTh{
    font-family: Montserrat !important;
    text-align: left !important;
    width: 200px;
    padding: 8px 0 !important;
    color: white;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Overview/Poules/PoulesCard.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB,iBAAiB;AACjB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,EAAE,SAAS;AAC5B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;EACb;;;EAGA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,WAAW;EACb;;EAEA;;IAEE,YAAY;IACZ,kBAAkB;IAClB,mBAAmB,EAAE,iCAAiC;EACxD;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,MAAM;IACN,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kCAAkC;IAClC,2BAA2B;IAC3B,YAAY;IACZ,yBAAyB;IACzB,YAAY;EACd","sourcesContent":[".poulesCardContainer {\r\n    width: 100%;\r\n    display: flex;\r\n    padding: 16px;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 8px;\r\n    align-self: stretch;\r\n    border-radius: 12px;\r\n    background: #69C3C5;\r\n}\r\n\r\n.poulesCardContainer p{\r\n    color: white;\r\nfont-family: Lato;\r\nfont-size: 20px;\r\nfont-style: normal;\r\nfont-weight: 700;\r\nline-height: 100%; /* 12px */\r\n}\r\n\r\n.poulesCardSlider{\r\n    width: 100%;\r\n    min-height: 200px;\r\n    overflow-y: auto;\r\n}\r\n\r\n.poulesCardSliderContent{\r\n    width: 120%;\r\n}\r\n\r\n.poulesCardContainer {\r\n    background-color: #69C3C5;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    margin-bottom: 20px;\r\n    color: #fff;\r\n  }\r\n\r\n  \r\n  .poulesCardSlider {\r\n    overflow-x: auto;\r\n    padding: 16px 0;\r\n  }\r\n  \r\n  .poulesCardSliderContent {\r\n    display: inline-block;\r\n  }\r\n  \r\n  .teamsTable {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    color: #fff;\r\n  }\r\n  \r\n  .teamsTable th,\r\n  .teamsTable td {\r\n    padding: 8px;\r\n    text-align: center;\r\n    white-space: nowrap; /* Prevents table from breaking */\r\n  }\r\n  \r\n  .teamsTable th {\r\n    text-align: center;\r\n    background-color: none;\r\n    position: sticky;\r\n    top: 0;\r\n    font-family: Lato;\r\n  }\r\n  \r\n  .teamInfo {\r\n    display: flex;\r\n    align-items: center;\r\n    max-width: 200px;\r\n    padding: 16px 0!important;\r\n  }\r\n\r\n  .teamInfo span{\r\n    font-size: 100%;\r\n  }\r\n  \r\n  .teamLogo {\r\n    width: 40px;\r\n    height: 40px;\r\n    border-radius: 50%;\r\n    margin-right: 10px;\r\n  }\r\n  \r\n  .points {\r\n    width: 50px;\r\n    background-color: #c3d32c;\r\n    text-align: center;\r\n    font-weight: bold;\r\n    color: black;\r\n  }\r\n\r\n  th.points{\r\n    border-radius: 8px 8px 0 0;\r\n  }\r\n\r\n  .teamsTable tbody tr:last-child td.points{\r\n    border-radius:  0 0 8px 8px;\r\n  }\r\n\r\n  .defeat, .win, .null, .goalFor, .goalAgainst, .diff{\r\n    width: 50px;\r\n  }\r\n  \r\n  .teamTh{\r\n    font-family: Montserrat !important;\r\n    text-align: left !important;\r\n    width: 200px;\r\n    padding: 8px 0 !important;\r\n    color: white;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
